module.exports = __webpack_public_path__ + "img/active_over.688935d0.png";